import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { fetchConfig } from '@/hooks/fetch';
import fetch from '@/metrics/hooks/fetch';
import OmniSearch from '@/search/components/OmniSearch';
import selectors from '../hooks/selectors';
import HomeHeaderBackgroundImage from './HomeHeaderBackgroundImage';
import HomeHeaderHeadings from './HomeHeaderHeadings';
import HomeBannerAdvanced from './HomeBannerAdvanced';

const HomeBanner = ({ compact }) => {
  const intl = useIntl();
  const {
    allowDatasetsSearch, count, heading, readStatus,
  } = selectors.useHomeBanner();
  fetch.useFetchMetrics(
    { entities: ['datasets'] },
    readStatus,
    fetchConfig([allowDatasetsSearch], () => allowDatasetsSearch),
  );

  const searchInputMessage = () => (allowDatasetsSearch && count !== 0
    ? intl.formatMessage({ id: 'home.banner.input.datasets' }, { count })
    : intl.formatMessage({ id: 'home.banner.input.actions' }));

  return (
    <Container className={clsx('aridhia-home-header', compact && 'aridhia-home-header--compact')}>
      <HomeHeaderBackgroundImage>
        <HomeHeaderHeadings heading={heading} compact={compact} />
        <div className={clsx('ui input flex items-center justify-center w-100 mt-10', compact && 'mt-40')}>
          <OmniSearch category="home" placeholder={searchInputMessage()} showNoResults />
        </div>
        {allowDatasetsSearch && (<HomeBannerAdvanced compact={compact} />)}
      </HomeHeaderBackgroundImage>
    </Container>
  );
};

export default HomeBanner;
